import {Component, OnInit, Renderer2} from '@angular/core';
import {animation} from '../../../shared/animations/animations';
import 'rxjs/add/operator/take';
import {SurveyService} from '../surveys.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PreviousUrlService} from '../../../shared/services/previous-url.service';
import { AuthTokenService } from '../../../shared/services/auth-token.service';
import { SurveyFilterUIModel, SurveyQuestionFilterRawModel } from '../../../models/survey/survey.model';
import { IncludeSurveyModel } from '../../../models/summary/summary.model';
import { FilterOption } from '../../../shared/constants/filter.constants';
import { HideQuestionModel } from '../../../models/hide-question/hide-question.model';

@Component({
  selector: 'app-cuts',
  templateUrl: './cuts.component.html',
  styleUrls: ['../../surveys/box-view-version/box-view-version.component.less'],
  animations: [animation]
})
export class CutsComponent implements OnInit {

  surveyCut: any;
  surveyId: number;
  surveyTitle: string;
  menu = ['Rename', 'Preview', 'Edit', 'Delete'];
  showDeletePopup: boolean;
  cutForDelete: any;
  loader = false;
  oldTitle: string;
  isUser = AuthTokenService.isUser();
  isCustomerUser = AuthTokenService.isCustomerUser();

  isFilteringQuestion = false;
  listSurveyQuestionRawFilter: SurveyQuestionFilterRawModel[] = [];
  listSurveyFilterUI: SurveyFilterUIModel[] = [];
  filterOption = FilterOption.AND;
  includeSurvey: IncludeSurveyModel;
  hideQuestions: HideQuestionModel[] = [];
  
  showCutCreatePopup = false;
  cutId: number;

  constructor(
    protected surveyService: SurveyService,
    private route: ActivatedRoute,
    private router: Router,
    private shareService: PreviousUrlService,
    private renderer: Renderer2
  ) {

  }

  deleteCut() {
    this.loader = true;
    if (this.cutForDelete) {
      this.surveyService.deleteCut(this.cutForDelete.id).subscribe(_ => {
        this.loadData();
        this.loader = false;
        this.showDeletePopup = false;
        this.surveyService.removeSmartAnalysisWithoutAnalysisAllResults();
      }, _ => {
        this.loader = false;
        this.showDeletePopup = false;
      });
    }
  }

  onMenuSelect(event, c) {
    this.cutId = c.id;
    if (event === 'Delete') {
      this.showDeletePopup = true;
      this.cutForDelete = c;
    } else if (event === 'Rename') {
      this.renameCut(c);
    } else if (event === 'Edit') {
      this.includeSurvey = new IncludeSurveyModel();
      this.surveyService.getCut(c.id).subscribe(res => {
        res.listQuestionFilter.forEach(filterItem => {
          if ((filterItem.input === 'No response given' || filterItem.input === 'Response given') && !filterItem.operator) {
            filterItem.operator = 'Response given';
            if (filterItem.input === 'No response given') {
              filterItem.input = 'False';
            } else {
              filterItem.input = 'True';
            }
          }
        });
        this.applySurveyFilterUI(res.listQuestionFilter);
        this.getListIncludeVersionCut(this.surveyId, res.listVersion, () => {
          this.isFilteringQuestion = true;
          this.renderer.addClass(document.body, 'modal-open');
        });
        this.filterOption = res.isOrOperator;
      });
      
    } else {
      this.includeSurvey = new IncludeSurveyModel();
      this.surveyService.getCut(c.id).subscribe(res => {
        res.listQuestionFilter.forEach(filterItem => {
          if ((filterItem.input === 'No response given' || filterItem.input === 'Response given') && !filterItem.operator) {
            filterItem.operator = 'Response given';
            if (filterItem.input === 'No response given') {
              filterItem.input = 'False';
            } else {
              filterItem.input = 'True';
            }
          }
        });
        this.applySurveyFilterUI(res.listQuestionFilter);
        this.getListIncludeVersionCut(this.surveyId, res.listVersion, () => {
          this.showCutCreatePopup = true;
          this.renderer.addClass(document.body, 'modal-open');
        });
        this.filterOption = res.isOrOperator;
      });
    }
  }

  ngOnInit() {
    if (this.isUser || this.isCustomerUser) {
      this.menu = ['Rename', 'Preview', 'Edit'];
    }
    this.surveyId = parseInt(this.route.snapshot.paramMap.get('id'), 0);
    this.loader = true;
    this.loadData();
  }

  loadData() {
    this.surveyService.getCuts(this.surveyId).subscribe(res => {
      this.surveyCut = res;
      this.surveyCut.listCut.forEach(c => {
        c.isRenaming = false;
      });
      this.surveyCut.listCut.sort((a, b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1);
      this.shareService.setSurveyTitle('Segments for ' + res.title);
      this.surveyTitle = res.title;
      this.loader = false;
    }, _ => {
      this.loader = false;
    });

    this.getListSurveyQuestionFilter(this.surveyId);
    this.getHideQuestion(this.surveyId);
  }

  getListSurveyQuestionFilter(surveyId: number) {
    this.surveyService.getListSurveyQuestionFilter(surveyId).subscribe((response) => {
      this.listSurveyQuestionRawFilter = response;
    }, _ => {
    });
  }

  getHideQuestion(surveyId: number) {
    this.surveyService
      .getHideQuestion(surveyId)
      .subscribe(res => {
        this.hideQuestions = res;
        this.hideQuestions = this.hideQuestions.sort((a, b) => a.questionId < b.questionId ? -1 : 1);
      }, _ => {
      });
  }

  renameCut(item: any) {
    item.isRenaming = true;
    this.oldTitle = item.title;
    setTimeout(_ => {
      const element = document.getElementById('renameInput' + item.id);
      element.focus();
    }, 50);
  }

  keyPress(key: string, item: any) {
    switch (key) {
      case 'enter':
      case 'tab':
        item.isRenaming = false;
        if (item.title) {
          this.oldTitle = null;
          this.surveyService.updateCutTitle(item.id, item.title).subscribe(_ => {
          }, _ => {
          });
        }
        break;
      case 'esc':
        item.isRenaming = false;
        item.title = this.oldTitle ? this.oldTitle : item.title;
        break;
      default:
        break;
    }
  }

  onClickCutTile(event: any, cut: any) {
    var origin = event.srcElement || event.target;
    if (origin.tagName && origin.tagName.match(/input/i)) {
      return;
    } else {
      this.surveyService.removeSmartAnalysisWithoutAnalysisAllResults();
      this.router.navigate([`surveys/master-summary/${this.surveyId}`], {queryParams: {cut: cut.id}});
    }
  }

  navigateAnalysisPage() {
    this.router.navigate([`surveys/master-summary/${this.surveyId}`]);
  }

  onQuestionFilterFinished(filter) {
    if (this.cutId) {
      this.surveyService.updateCut(this.cutId, {
        listQuestionFilter: filter.listSurveyFilterUI,
        isOrOperator: filter.isOrOperator,
        listVersion: this.includeSurvey.listSurveyVersion.map(item => item.hash)
      }).subscribe(_ => {}, _ => {});
    }
    
    this.filterOption = filter.isOrOperator;
    this.surveyService.removeSmartAnalysisWithoutAnalysisAllResults();
     this.applySurveyFilterUI(filter.listSurveyFilterUI);
    this.isFilteringQuestion = false;
    this.renderer.removeClass(document.body, 'modal-open');
  }

  onQuestionFilterCancelled(close: boolean) {
    this.isFilteringQuestion = false;
    this.renderer.removeClass(document.body, 'modal-open');
  }

  applySurveyFilterUI(listSurveyFilterUI) {
    this.listSurveyFilterUI = listSurveyFilterUI ? listSurveyFilterUI.filter(s => s.isChecked && s.question) : [];
  }

  getListIncludeVersionCut(id: number, listVersionHash?: string[], callback?: () => any) {
    const cb = callback || function () {
    };
    this.surveyService.getListIncludeVersion(id).toPromise().then(
      res => {
        let listSurveyVersion = res.versions;
        if (listVersionHash && listVersionHash.length > 0) {
          listSurveyVersion.forEach(x => listVersionHash.indexOf(x.hash) > 0 ? x.isSelected = true : x.isSelected = false);
        } else {
          listSurveyVersion.forEach(x => x.isSelected = true);
        }
        this.includeSurvey.compare = false;
        this.includeSurvey.allVersionSelected = listVersionHash ? false : true;
        let listIncludeVersion = res.versions;
        if (listVersionHash && listVersionHash.length > 0) {
          listIncludeVersion = listIncludeVersion.filter(x => listVersionHash.indexOf(x.hash) >= 0 || (listVersionHash[0] == (null) && x.hash == null));
        }
        listIncludeVersion.forEach(x => x.isSelected = true);
        this.includeSurvey.listSurveyVersion = listIncludeVersion;
        cb();
      }, _ => {
      }
    );
  }
  closePreviewCutTile() {
    this.showCutCreatePopup = false;
    this.renderer.removeClass(document.body, 'modal-open');
  }
  onSaveAsCut(event) {
    this.closePreviewCutTile();
    this.surveyService.saveCut({
      surveyId: this.surveyId,
      title: event,
      listQuestionFilter: this.listSurveyFilterUI,
      isOrOperator: this.filterOption,
      listVersion: this.includeSurvey.listSurveyVersion.map(item => item.hash)
    }).subscribe(_ => {
      this.surveyService.resetSmartAnalysisResults();
    }, _ => {
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/cut/cuts.component.ts